import React from 'react';
import { signOut } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';

const Header = ({ user, setUser }) => {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut();
      // Clear user from state
      setUser(null);
      // Navigate to home page
      navigate('/');
    } catch (error) {
      console.log('Error signing out: ', error);
    }
  };

  return (
    <header className="header">
      <div className="logo" onClick={() => navigate('/')}>NIGHT BACON</div>
      <nav className="nav-links">
        <a href="/">Home</a>
        {user ? (
          <>
            <a href="/files">Files</a>
            <a href="/calendar">Calendar</a>
            <button onClick={handleSignOut}>Sign Out</button>
          </>
        ) : (
          <a href="/login">Login</a>
        )}
      </nav>
    </header>
  );
};

export default Header;
